import * as React from 'react';
import * as classnames from 'classnames';
var Spinner = function (props) {
    var variant = props.variant, tubeColor = props.tubeColor;
    var spinnerClass = classnames(props.className || '', {
        'inline-spinner': true,
    });
    if (variant === 'tube') {
        return (React.createElement("span", { className: spinnerClass },
            React.createElement("span", { className: "bounce1", style: {
                    backgroundColor: tubeColor || 'black',
                } }),
            React.createElement("span", { className: "bounce2", style: {
                    backgroundColor: tubeColor || 'black',
                } }),
            React.createElement("span", { className: "bounce3", style: {
                    backgroundColor: tubeColor || 'black',
                } })));
    }
    return (React.createElement("span", { className: spinnerClass },
        React.createElement("span", { className: "bounce1" }),
        React.createElement("span", { className: "bounce2" }),
        React.createElement("span", { className: "bounce3" })));
};
export default Spinner;



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/Spinner.tsx
// module id = 413
// module chunks = 81